<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <lg-form-const-select label="Situação:" sm="2" md="2" v-model="form.situacao"
                        :options="form.optionsFilterSituacao" @change="load()" />

                    <lg-form-input v-model="form.nome" label="Nome:" description=" " cols="6" sm="6" md="6" />
                    <b-col cols="1" class="mt-2">
                        <b-button id="localizarAntena" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" /> &nbsp;
                            </div>
                            <b-tooltip target="localizarAntena" title="Localizar"></b-tooltip>

                        </b-button>

                    </b-col>


                    <b-col cols="1" class="text-right mt-2">

                        <b-button v-if="temPrivilegioCriacao()" id="novoAntena" class=" my-2" size="sm"
                            style="height: 20px" pill variant="primary" @click="mostrarModal">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" /> &nbsp;
                            </div>
                            <b-tooltip target="novoAntena" title="Adicionar novo..."></b-tooltip>

                        </b-button>

                    </b-col>
                </b-form-row>

                <b-form-row>

                    <span v-if="showSelect">{{ itensSelecionados.length }} item(s) selecionado(s)</span>
                    <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                        :fields="this.tableFields" :hover="true" show-empty @row-dblclicked="clickRow">

                        <template #empty>
                            <p>Nenhum registro encontrado</p>
                        </template>


                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                        </template>

                        <template v-slot:cell(select)="row">
                            <b-form-checkbox :value="true" :unchecked-value="false" @change="marcar(row.item)"
                                v-model="row.item.selecionado"></b-form-checkbox>

                        </template>


                        <template v-slot:cell(ip)="row">
                            <span>{{ row.item.ip }}<b-icon icon="hdd-network-fill"></b-icon></span>
                        </template>

                        <template v-slot:cell(situacao)="row">
                            <div :id="row.index + 'switchGrupo'">
                                <b-form-checkbox v-b-tooltip.hover.bottom="'Ativar/Desativar...'"
                                    :disabled="!temPrivilegioEdicao()" v-model="row.item.situacao"
                                    @change="alteraSituacao(row.item)" name="check-button" switch size="lg" :value="1"
                                    :unchecked-value="0" />
                            </div>
                        </template>
                        <template v-slot:cell(sincronizar)="row">
                            <b-button v-b-tooltip.hover.bottom="'Sincronizar Antenas'" class="mr-2 my-2" size="sm" pill
                                variant="primary" @click="sincronizar(row.item.id)" style="height: 30px">
                                <div>
                                    <b-icon icon="arrow-clockwise" />
                                </div>

                            </b-button>
                        </template>
                        <template v-slot:cell(action)="row">

                            <b-button v-b-tooltip.hover.bottom="'Editar'" :disabled="!temPrivilegioEdicao()"
                                :id="row.index + 'edit-button'" class="my-2" size="sm" pill variant="primary"
                                @click="editar(row.item)">
                                <b-icon icon="pencil-square" />
                            </b-button>
                        </template>

                        <template #cell(expand)="row">
                            <b-button @click="row.toggleDetails" variant="primary" size="sm"
                                class="align-items-center justify-content-center d-flex">{{ row.detailsShowing ? "-" :
                                    "+"
                                }}

                            </b-button>
                        </template>

                        <template #row-details="row">
                            <ul class="list-group list-group-flush w-100">
                                <li v-for="(antena, index) in row.item.antenas" :key="index"
                                    @click="clickRowAntena(row.item, antena, index)"
                                    class="list-group-item d-flex align-items-center justify-content-between">
                                    <span class="fw-bold">Antena {{ index + 1 }}</span>

                                    <b-form-group label="Nome:" style="margin-top: 4px;">
                                        <b-form-input @blur="onBlurDescricao(row.item.id, index, antena.descricao)"
                                            style="max-height: 21px; max-width: 200px;" type="text"
                                            v-model="antena.descricao" />
                                    </b-form-group>
                                    <lg-form-const-select :disabled="antena.situacao == 0" sm="2" md="2"
                                        label="Tipo de Antena:" v-model="antena.tipoAntena"
                                        :options="form.optionsTipoAntenas"
                                        @change="mudarTipoAntena(row.item.id, index, antena.tipoAntena)" />


                                    <div class="d-flex" style="min-width: 50px;">
                                        <input :disabled="antena.situacao == 0" type="range" class="form-range mx-2"
                                            min="0" max="200" v-model="antena.potencia"
                                            @change="onPotenciaChange(row.item.id, index, antena.potencia)"
                                            style="width: 120px;" />

                                        <b-icon :id="'antena' + index" icon="broadcast"
                                            :variant="antena.situacao ? 'primary' : 'danger'" font-scale="1.5"
                                            class="ms-2" />
                                        <b-tooltip :target="'antena' + index"
                                            :title="antena.situacao == 1 ? 'Disponível' : 'Indisponível'"></b-tooltip>

                                        <b-button :id="index + 'historico-button-antena'" class="ml-2 " size="sm" pill
                                            variant="primary" @click="abrirModalHistoricoAntena(row.item, antena)"
                                            v-b-tooltip.hover.bottom="'Histórico de Leitura...'">
                                            <b-icon icon="list" />

                                        </b-button>

                                    </div>
                                </li>
                            </ul>
                        </template>

                        <template #cell(historico)="row">
                            <b-button :id="row.index + 'historico-button'" class="my-2" size="sm" pill variant="primary"
                                @click="abrirModalHistorico(row.item)"
                                v-b-tooltip.hover.bottom="'Histórico de Leitura...'">
                                <b-icon icon="list" />
                            </b-button>
                        </template>


                    </b-table>
                </b-form-row>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>

                <b-form-row v-if="showSelect">

                    <b-col cols="3"></b-col>
                    <b-col cols="6" class="text-center">
                        <b-button id="salvar-leitor" class=" my-2" size="sm" pill variant="success"
                            @click="selecionarTodos">
                            <b-icon icon="check-circle" />
                            <b-tooltip target="salvar-leitor" title="Selecionar"></b-tooltip>

                        </b-button>

                    </b-col>
                    <b-col cols="3"></b-col>

                </b-form-row>



            </b-card>
        </b-card-body>

        <LeitorForm v-if="show" @close="cancelar" :prefix="prefix + title + ' > '" :id="id" />


        <ModalHistoricoLeituraLeitor :prefix="prefix + title + ' > '" v-if="showModalHistorico"
            @fecharModal="fecharModalLeitor" :antena="antena" :leitor="leitor"></ModalHistoricoLeituraLeitor>

    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import LeitorForm from "./LeitorForm.vue";
import ModalHistoricoLeituraLeitor from './ModalHistoricoLeituraLeitor.vue'


export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        LeitorForm,
        ModalHistoricoLeituraLeitor
    },
    props: {
        showSelect: {
            type: Boolean,
            default: false
        },
        podeClicarNaAntenaParaSelecionar: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            itensSelecionados: [],
            showModalHistorico: false,
            antena: null,
            leitor: null,
            title: 'Leitor',
            id: null,
            show: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            form: {
                nome: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
                optionsTipoAntenas: [
                    { key: "filtertipoAntena", text: "Saída oficial", value: 1 },
                    { key: "filtertipoAntena", text: "Interna", value: 2 },
                ],
            },
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/leitor`);
    },
    mounted() {
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            const fields = [];

            if (this.showSelect)
                fields.push({ key: "select", label: " " });

            fields.push(
                { key: "expand", label: " " },
                { key: "nome", label: "Nome" },
                { key: "ip", label: "IP" },
                { key: "sincronizar", label: " ", tdClass: "w-1" },

                { key: "action", label: " ", tdClass: "w-1" },
                { key: "situacao", label: " ", tdClass: "w-1" },
                { key: "historico", label: " ", tdClass: "w-1" }
            );

            return fields;
        }
    },
    methods: {
        async sincronizar(leitor) {
            this.busy = true;
            await this.$service.put(`sincronizar-antenas/${leitor}`, {});
            this.$notify({
                type: "success",
                message: "Leitor sincronizado com sucesso"
            });

            this.load();
        },
        selecionarTodos() {
            if (this.itensSelecionados.length == 0) {
                this.$notify({
                    type: "danger",
                    message: "Selecione ao menos um leitor"
                });

                return;
            }
            this.$emit("closeMultiplo", this.itensSelecionados);
        },
        marcar(item) {
            if (item.selecionado)
                this.itensSelecionados.push(item);
            else {
                this.itensSelecionados.splice(
                    this.itensSelecionados.indexOf(item),
                    1
                );

            }
        },
        mudarTipoAntena(leitor, antena, tipoAntena) {
            this.$service.put(`${leitor}/${antena}/${tipoAntena}/tipo-antena`, {});
        },
        fecharModalLeitor() {
            this.antena = null;
            this.leitor = null;
            this.showModalHistorico = false;
        },
        abrirModalHistoricoAntena(leitor, antena) {
            this.antena = antena.id;
            this.leitor = leitor.id;
            this.showModalHistorico = true;

        },
        abrirModalHistorico(leitor) {
            this.antena = null;
            this.leitor = leitor.id;
            this.showModalHistorico = true;

        },
        onPotenciaChange(leitor, antena, potencia) {
            this.$service.put(`${leitor}/${antena}/${potencia}/potencia`, {});

        },

        onBlurDescricao(leitor, antena, descricao) {
            if (!descricao)
                descricao = " ";
            this.$service.put(`${leitor}/${antena}/${descricao}/descricao`, {});

        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);
        },
        temPrivilegioCriacao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);
        },
        async editar(item) {
            this.id = item.id;
            this.show = true;
        },
        async load() {
            this.filtro = {};
            if (this.form.nome)
                this.filtro.nome = this.form.nome;

            if (this.form.situacao != null)
                this.filtro.situacao = this.form.situacao;

            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

            if (this.showSelect) {
                this.itensSelecionados.forEach(item => {
                    this.records.forEach(record => {
                        if (record.id == item.id)
                            record.selecionado = true;
                    })
                });
            }
        },
        cancelar() {
            this.id = null;
            this.show = false;
            this.load();
        },
        mostrarModal() {
            this.id = null;
            this.show = true;
        },

        async clickRowAntena(item, antena, index) {
            antena.index = index + 1;
            item.antena = antena;

            if (this.podeClicarNaAntenaParaSelecionar)
                this.$emit("close", item);
        },

        async clickRow(item) {
            if (!this.podeClicarNaAntenaParaSelecionar)
                this.$emit("close", item);
        },

        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Leitor?",
                item.nome.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            try {
                await this.$service.put(`${item.id}/situacao`, item);
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                });
            }
            catch ({ response }) {
                const { data } = response;
                item.situacao = item.situacao ? 0 : 1;
                this.$notify({
                    type: "danger",
                    message: data
                });
            }
        }
    },
};
</script>
